import {
  Alert,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from '@nextiva/next-ui-components';
import React, { useState } from 'react';
import { Controller, useForm } from 'react-hook-form-new';
import { formatToPhoneNumber } from 'utils/phone-number';
import { useGetPhoneNumberByCarrier } from '../CampaignDialog/WizardContextV3/useGetPhoneNumberByCarrier';
import { MenuProps } from '../CampaignDialog/constants';
import { useEnableSmsSP } from '../CampaignDialog/WizardContextV3/useEnablePhoneNumberSP';
import { ButtonStyled2 } from '../MessagingNew.styled';

const dataTestId = 'PlatformAdminUI-Messaging-SPBusinessMessagingForm';
export function SPBusinessMessagingForm({ carrier }: { carrier: string }) {
  const {
    control,
    formState: { isValid },
    getValues,
  } = useForm({
    mode: 'onChange',
    defaultValues: {
      numberSP: '',
    },
  });
  const [hideSPForm, setHideSPForm] = useState(false);
  const phoneNumbersByCarrier = useGetPhoneNumberByCarrier(carrier);
  const { mutateAsync: enableSmsSP, isLoading } = useEnableSmsSP();

  const handleSubmit = async () => {
    const { numberSP } = getValues();
    await enableSmsSP(numberSP);
    setHideSPForm(true);
  };

  return (
    !hideSPForm && (
      <Grid container rowSpacing={3} data-testid={dataTestId}>
        <Grid container xs={12}>
          <Typography variant="subtitle2" color="text.primary">
            Select number for business messaging
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Alert severity="warning" fullWidth>
            Please note this selection is final. You may have to resubmit
            application if you want to change business messaging number in the
            future.
          </Alert>
        </Grid>
        <Grid container item columnSpacing={4} alignItems="end">
          <Grid item xs={4}>
            <InputLabel id="select-number">
              <Typography
                variant="body2"
                color="#55596B"
                sx={{ textTransform: 'none' }}
              >
                Business messaging number
              </Typography>
            </InputLabel>
            <Controller
              control={control}
              name="numberSP"
              rules={{ required: true }}
              render={({ field: { onChange, onBlur, value } }) => (
                <Select
                  data-testid={`${dataTestId}-SelectNumber`}
                  onChange={onChange}
                  onBlur={onBlur}
                  value={value}
                  fullWidth
                  placeholder="Select"
                  MenuProps={MenuProps}
                >
                  {phoneNumbersByCarrier.data?.data?.map(
                    (phoneNumber: string) => (
                      <MenuItem key={phoneNumber} value={phoneNumber}>
                        {formatToPhoneNumber(phoneNumber)}
                      </MenuItem>
                    ),
                  )}
                </Select>
              )}
            />
          </Grid>
          <Grid item xs={3}>
            <ButtonStyled2
              disabled={!isValid || isLoading}
              onClick={handleSubmit}
              variant="contained"
              data-testid={`${dataTestId}-SubmitButton`}
              color="primary"
            >
              Submit
            </ButtonStyled2>
          </Grid>
        </Grid>
      </Grid>
    )
  );
}
